import { Box, Card, Flex, Grid, Heading, Text } from '@workos-inc/design-system';
import NextLink from 'next/link';
import { AUTHKIT_STACK_OPTIONS } from 'src/utils/authkit-stack-options';
export const AuthKitStackGrid = () => <Grid columns={{
  sm: '2',
  md: '3'
}} gap="4" data-sentry-element="Grid" data-sentry-component="AuthKitStackGrid" data-sentry-source-file="authkit-stack-grid.tsx">
    {AUTHKIT_STACK_OPTIONS.map(({
    title,
    description,
    href,
    icon: Icon
  }) => <Card key={href} asChild size="2" variant="classic">
        <NextLink href={href}>
          <Flex direction="column" gap="3">
            <Box style={{
          color: 'var(--gray-a9)'
        }}>
              <Icon height="32" width="32" />
            </Box>
            <Box>
              <Heading as="h3" mb="1" size="3">
                {title}
              </Heading>
              <Text as="div" color="gray" size="2">
                {description}
              </Text>
            </Box>
          </Flex>
        </NextLink>
      </Card>)}
  </Grid>;